import {
  BookedWorkCell,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';

/**
 * Column and collapse definitions for the site plots ledger. Screens own
 * these; the shared layer only reads them.
 */

/** CSS container the plots list declares, so the collapse point tracks the
 * list width rather than the viewport (the side panel changes one, not the
 * other). */
export const SITE_LEDGER_CONTAINER = 'site-plots';

export const SITE_LEDGER_COLLAPSE: LedgerCollapse = {
  container: SITE_LEDGER_CONTAINER,
  at: 620,
};

/** Site is implied by the page and plot by the band, so neither is a column. */
export const SITE_LEDGER_COLUMNS: LedgerColumn[] = [
  { key: BookedWorkCell.Ref, label: 'Ref', flex: 1 },
  { key: BookedWorkCell.BookedBy, label: 'Booked by', flex: 1.2 },
  { key: BookedWorkCell.When, label: 'When', flex: 1.1 },
];

/** Below this the plot band drops its percentage caption. */
export const BAND_PERCENT_HIDDEN_BELOW = 480;
